export interface HelpStep {
  text: string;
  imageUrl?: string;
}

export interface StructuredHelp {
  steps: HelpStep[];
}

export type HelpText = string | StructuredHelp;

export interface IntegrationField {
  name: string;
  label: string;
  type: string; // 'text' | 'password' | 'date' | 'number' | 'boolean'
  required: boolean;
  helpText?: HelpText;
  storeInKeyVault?: boolean;
}

export interface WorkItemType {
  id: string;
  name: string;
  description?: string;
}

export interface IntegrationWrapper {
  integration: Integration;
  configured: boolean;
  configFields: IntegrationField[];
  customerIntegrations?: Array<CustomerIntegration>;
  isStatusEnabled: boolean;
}

export interface CustomerIntegration {
  id: number;
  configValues: Record<string, any>;
  status: string | null;
  statusReason: string | null;
  lastRunTime: string | null;
  nextScheduledRun: string | null;
  //monthsOfData: number | null;
  isEnabled: boolean;
}

export interface CustomerIntegrationMetaData {
  Id: number;
  CustomerIntegrationId: number;
  Key: string;
  Value: string;
  CreatedAt: string;
  UpdatedAt: string;
  DeletedAt: string | null;
}

export interface Integration {
  Id: number;
  Name: string;
  Description: string;
  CategoryName: string;
  Icon: string;
  Enabled: boolean;
  ConfigFields: string;
  AllowMultiple: boolean;
}

export interface User {
  userId: number;
  email: string;
  firstName: string | null;
  lastName: string | null;
  customerId: number;
  customerName?: string;
  isActive: boolean;
  role: string;
  createdAt: string;
  lastLoginAt: string | null;
}

export const INTEGRATION_TYPE_IDS = {
  AZURE_DEVOPS: 1,
  JIRA: 2,
  SERVICENOW: 3
} as const;
